var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericHomeCard',{attrs:{"shiftTypeId":_vm.survey.ShiftTypeId,"linkTo":{ name: 'survey', params: { survey_id: _vm.survey.Id} },"mainTitle":'survey_questionnaire',"subTitle":_vm.survey.Title,"content":_vm.survey.RoundName,"buttonCaption":_vm.$t('survey_enter_questions')}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a800b04e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/surveys/Survey.vue
// module id = null
// module chunks = 